var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProstate1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08984 9.9541C9.08984 9.9541 11.6528 13.4905 14.9011 10.1528",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08984 13.7293C9.08984 13.7293 11.772 11.3352 14.9011 13.6796",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0426 8.53285L12.824 8.23484C12.1585 7.32093 10.8869 7.09245 9.9432 7.70835L9.72469 7.85735L9.49623 7.82755C8.31411 7.65868 7.16177 8.23484 6.61541 9.26795C6.29753 9.86398 6.32735 10.5792 6.6949 11.1554L7.22136 11.9997L6.97301 12.6752C6.85381 13.0031 6.8439 13.4699 6.8737 13.907C6.91343 14.4832 7.3505 14.9401 7.90679 15.0991C8.50282 15.268 8.48294 15.4766 8.70148 15.8044C8.95976 16.1918 9.58563 16.4699 10.0525 16.4401C10.4499 16.4203 10.8373 16.3408 11.2148 16.2117L12.4366 15.7944L12.675 15.864C13.6684 16.7282 15.3075 17.2646 15.8141 15.2381C15.8141 15.2381 16.6982 15.2382 17.1353 14.513C17.6916 13.5792 17.1254 12.4964 17.1254 12.4964C17.7313 11.4832 17.8406 10.7878 16.9664 9.92358C16.8571 9.73484 16.877 9.35735 16.6883 8.9302C16.4101 8.26464 15.2776 7.48981 14.2247 7.87722L13.0426 8.52292V8.53285Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProstate1);
export default __webpack_public_path__ + "static/media/Prostate-1.448865037647f7640f4a6cc8d48412f3.svg";
export { ForwardRef as ReactComponent };